import { render, staticRenderFns } from "./SubLibraries.vue?vue&type=template&id=4afad81e"
import script from "./SubLibraries.vue?vue&type=script&lang=js"
export * from "./SubLibraries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports